import { combineReducers } from 'redux'
import { combineActions, handleActions } from 'redux-actions'

import {
  loadCmsJobs,
  loadCmsJobsFailure,
  loadCmsJobsSuccess
} from './actions'
import {
  defaultItems,
  defaultLoading,
  defaultTotalSize
} from './defaultState'

const items = handleActions({
  [loadCmsJobsSuccess]: (_, { payload }) => payload
}, defaultItems)

const loading = handleActions({
  [loadCmsJobs]: () => true,
  [combineActions(loadCmsJobsSuccess, loadCmsJobsFailure)]: () => false
}, defaultLoading)

const totalSize = handleActions({
  [loadCmsJobsSuccess]: (_, { meta: { resultSize } }) => resultSize
}, defaultTotalSize)

export default combineReducers({ items, loading, totalSize })
